import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';
import { c as classNames } from '../../../../index-e609ebf3.js';
import '../../../../_commonjsHelpers-17aad09c.js';

var List = function (_a) {
    var children = _a.children, forStatistics = _a.forStatistics, rest = __rest(_a, ["children", "forStatistics"]);
    var listClassNames = classNames('lists-wrapper', {
        statistics: forStatistics,
    });
    return (React.createElement("div", __assign({ className: listClassNames }, rest), children));
};

export { List };
